
import { Event }     from './event';
import { EventType } from './event.type';

/**
 *
 * @class NewPanoEvent
 *
 * when a new pano has been setup
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class ErrorEvent extends Event {

  /** category of error*/
  private _kind: string = '';

  /** the error message */
  private _error: string = '';

  /** standard constructor */
  constructor(krpano : any, kind : string,  msg : string) {

    super(krpano, EventType.NEW_PANO);

    this._kind  = kind;
    this._error = msg;

  }

  /** fetch the category of the error */
  kind(): string {

    return this._kind;
  }

  /** fetch the error */
  error(): string {

    return this._error;
  }

}
